import styled from 'styled-components/macro';

export default styled.p`
  ${props => props}
  font-size: ${props => props.theme.old.fontSize[28]};
  font-weight: ${props => props.theme.old.fonts.weight.semibold};
  color: ${props => props.theme.old.colors[props.color] || props.theme.old.colors.eerieBlack};
  font-weight: ${props => props.theme.old.fonts.weight[props.weight] || props.theme.old.fonts.weight.semiBold};
  line-height: 35px;
`;